import { IconTypeEnum } from "../enums/icon-button.enum";
import { ButtonTypesEnum } from "./button";

export interface IDropdownOptions<T> {
    id: string;
    payload?: T;
    label: string;
    disabled?:boolean;
    iconType?: DropdownTypeEnum;
    isSelectAll?: boolean;
}

export interface IDropdownConfig {
  svg: string;
  color: string
}

export enum TemplateDropdownEnum {
  GREY,
  LIGHT,
  WHITE
}

export enum DropdownTypeEnum {
  WARNING = 1,
  ERROR,
  SUCCESS
}

export interface IMultiDropdownConfig{
  indexCol: number;
  config: IDropdownOptions<any>[];
}

export interface IMultiDropdownSelected{
  indexCol: number;
  selected: IDropdownOptions<any>;
}

export interface IMultiDate{
  indexCol: number;
  value: string;
  showDatePicker: boolean;
  formControl: any;
  showError?: boolean;
  errorMessage?: string;
  maxDate?: string;
  minDate?: string;
}

export interface IMultiButton{
  indexCol: number;
  label: string;
  buttonType: ButtonTypesEnum;
  disabled: boolean;
  isIcon?: boolean;
  iconType?: IconTypeEnum;
  isHidden?: boolean
}
